import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"

import IntroductionCard from "./introductionCard"
import ProductCard from "./productCard"
import Point from "./point"
import UnfilterTime from "./unfilterTime"
import News from "./news"
import Campaign from "./campaign"
import AnimeButton from "../components/AnimeButton"
import InstagramCards from "../components/InstagramCards"

const BlackButton = styled(Button)`
  width: 207px;
  height: 45px;
  margin: auto;
  border: 1px solid #6e6e6e;
  background: #6e6e6e;
  text-align: center;
  border-radius: 0;
`

const IntroductionCardPosition = styled(Box)`
  @media screen and (min-width: 600px) and (max-width: 1020px) {
    top: -50px;
  }
  @media screen and (min-width: 1020px) and (max-width: 1280px) {
    top: -50px;
  }
  @media screen and (min-width: 1280px) {
    top: -100px;
  }
`

function TopContent() {
  const data = useStaticQuery(graphql`
    query {
      top_content_image: file(relativePath: { eq: "up10_20211115.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      top_unfilter_main_logo: file(
        relativePath: { eq: "top_unfilter_main_logo.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      top_unfilter_logo: file(relativePath: { eq: "introduction_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      top_unfilter_logo: file(relativePath: { eq: "introduction_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      profile_img_1: file(relativePath: { eq: "introduction_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Box width="100%" minWidth="760px" position="relative">
        <Box
          position="absolute"
          zIndex={99}
          top={"25%"}
          left={"40%"}
          width="50%"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <Img fluid={data.top_unfilter_main_logo.childImageSharp.fluid} />
        </Box>

        <Grid container alignItems="center">
          <Grid
            item
            xs={7}
            data-aos="fade-in"
            data-aos-duration="1000"
            data-aos-delay="1000"
          >
            <Img
              style={{ width: "100%" }}
              fluid={data.top_content_image.childImageSharp.fluid}
            />
          </Grid>
          <Grid
            item
            xs={5}
            data-aos="fade-in"
            data-aos-duration="1000"
            data-aos-delay="1000"
          >
            <Grid
              container
              style={{ width: "90%", marginLeft: "3%", textAlign: "justify" }}
            >
              <WrapTypo isHunter={true} variant="h5" fs={"18px"} mt={"30%"}>
                心と体のフィルターを取り除くと私には艶と香りが残ります。
              </WrapTypo>
              <WrapTypo isHunter={true} fs={"14px"} lh={"200%"} mt={"3%"}>
                定期的に続けられる集中スキンケアプログラム「UNFILTER Treatment
                bath oil」
                <br />
                贅沢なアロマとプレミアムオイルが心と体のフィルターを取り除き
                <br />
                あなた本来の美しい肌へと導きます。
              </WrapTypo>
              <Box width="100%" m={"10% auto 0 0"}>
                <AnimeButton
                  style={{ margin: "0 10% 0 auto" }}
                  href="/product/"
                  text="詳しく見る"
                  height="clamp(30px,2.5vw,50px)"
                  width="clamp(120px,13vw,200px)"
                  fs="clamp(12px,1.2vw,16px)"
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* <Box
          position="absolute"
          width="100%"
          top="32px"
          right="40.49px"
          data-aos="fade-in"
          data-aos-duration="1000"
        >
          <Grid container justify="flex-end">
            <Box width="11%">
              <Img fluid={data.top_unfilter_logo.childImageSharp.fluid} />
            </Box>
          </Grid>
        </Box> */}
      </Box>
      <Box height="576.75px" bgcolor="#F4F4F4" position="relative">
        <IntroductionCardPosition position="absolute" width="100%">
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ marginBottom: "80px" }}
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="1000"
          >
            <IntroductionCard />
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            data-aos="fade-in"
            data-aos-duration="1000"
            data-aos-delay="1000"
          >
            <ProductCard />
          </Grid>
        </IntroductionCardPosition>
      </Box>
      <Box mt={"800px"}>
        <Point />
      </Box>
      <Box data-aos="fade-in" data-aos-duration="1000">
        <UnfilterTime />
      </Box>
      <Box data-aos="fade-in" data-aos-duration="1000">
        <News />
      </Box>
      {/* <Box data-aos="fade-in" data-aos-duration="1000"> */}
      <Campaign />
      {/* </Box> */}
    </>
  )
}

export default TopContent
